import { render } from "./EthStake.vue?vue&type=template&id=77024368"
import script from "./EthStake.vue?vue&type=script&lang=js"
export * from "./EthStake.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/EthStake.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77024368"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77024368', __exports__)) {
    api.reload('77024368', __exports__)
  }
  
  module.hot.accept("./EthStake.vue?vue&type=template&id=77024368", () => {
    api.rerender('77024368', render)
  })

}


export default __exports__